let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("covqK"), load("4hJCH"), load("hAerp")]).then(() => parcelRequire('kGWTg'));